import React from "react";
import { commentBackend, taskBackend, TaskFullData } from "../../services";
import {
  formatDateTimeStandard,
  generateRandomString,
  isEventOutdated,
} from "../../utils";
import ShortManInfo from "../../components/ui/shortItem";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../state/modalSlice";
import TaskAddUserModal from "../../modals/task/updateTaskUser";
import { actions } from "../../state/reducer";
import { toast } from "sonner";
import TaskDeleteUserModal from "../../modals/task/deleteUserFromTask";

const TaskInfoSidePanel = (props: { task: TaskFullData }) => {
  const { task } = props;
  const dispatch = useDispatch();

  const author = task.users.find((user) => user.status_id === 1);
  const executer = task.users.find((user) => user.status_id === 2) || author;

  const coExecuters = task.users.filter((user) => user.status_id === 3);
  const spectators = task.users.filter((user) => user.status_id === 4);

  const handleAddUserModal = (status_id: number) => {
    dispatch(
      openModal({
        component: TaskAddUserModal,
        context: {
          task_id: task.id,
          def_status_id: status_id,
          onSave: (
            userId: number,
            statusid: number,
            comment: string,
            itemid = task.id
          ) => {
            if (comment && comment.length > 0) commentBackend.addComment({
              tab_id: 2,
              item_id: task.id,
              comment,
            });
            Promise.all([
              taskBackend.addUserToTask({
                task_id: task.id,
                participant_id: userId,
                status_id: statusid,
              }),
            ])
              .then((res) => {
                if (res) {
                  dispatch(actions.selectItem(generateRandomString(4)));
                  toast("Пользователь успешно добавлен");
                }
              })
              .catch((err) => {
                toast("ошибка добавления пользователя");
              })
              .finally(() => {
                dispatch(closeModal());
              });
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const handleDeleteUserModal = (user_id: number) => {
    dispatch(
      openModal({
        component: TaskDeleteUserModal,
        context: {
          task_id: task.id,
          user_id,
          onSave: (comment: string) => {
            Promise.all([
              commentBackend.addComment({
                tab_id: 2,
                item_id: task.id,
                comment,
              }),
              taskBackend.deleteUserFromTask({
                task_id: task.id,
                participant_id: user_id,
              }),
            ])
              .then((res) => {
                if (res) {
                  dispatch(actions.selectItem(generateRandomString(4)));
                  toast("Пользователь удален");
                }
              })
              .catch((err) => {
                toast("ошибка удаления пользователя");
              })
              .finally(() => {
                dispatch(closeModal());
              });
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };
  console.log("Status:", task.status_id, task.status_id === 3);

  const isOutdated = task.date_end ? isEventOutdated(task.date_end) : false;

  const headColor =
    task.status_id === 3
      ? "green"
      : task.status_id === 2
      ? "gray"
      : isOutdated
      ? "red"
      : "yellow";

  return (
    <div className="panel w100">
      <div className={`taskInfoPanelHeading ${headColor}`}>
        {task.status_id === 3
          ? "Выполнено" :
          task.status_id === 2 ?
          "Завершено"
          : `Ждёт выполнения с ${formatDateTimeStandard(task.date_start)}`}
      </div>
      <div className="inner">
        <div className="flex between taskInfoRow">
          <span>Крайний срок</span>
          <span>
            {task.date_end ? formatDateTimeStandard(task.date_end) : "Нет"}
          </span>
        </div>
        {/* <div className="flex between taskInfoRow">
          <span>Напоминание</span>
          <span>
            <a>Напомнить</a>
          </span>
        </div> */}
        <div className="flex between taskInfoRow">
          <span>Поставлено</span>
          <span>
            {task.date_start
              ? formatDateTimeStandard(task.date_start)
              : "Неизвестно"}
          </span>
        </div>
        <div className="columnLeft gap12 taskInfoRow">
          <div className="flex between w100">
            <span>Постановщик</span>
          </div>
          {author && (
            <ShortManInfo
              photo={author.info?.photo}
              name={author.info?.name}
              last_name={author.info?.last_name}
              first_name={author.info?.first_name}
              phone={author.info?.phone}
            />
          )}
        </div>
        <div className="columnLeft gap12 taskInfoRow">
          <div className="flex between w100">
            <span>Исполнитель</span>
            <span>
              <a onClick={handleAddUserModal.bind(this, 2)}>Назначить</a>
            </span>
          </div>
          {executer && (
            <ShortManInfo
              photo={executer.info?.photo}
              name={executer.info?.name}
              last_name={executer.info?.last_name}
              first_name={executer.info?.first_name}
              phone={executer.info?.phone}
            />
          )}
        </div>
        <div className="columnLeft gap12 taskInfoRow">
          <div className="flex between w100">
            <span>Соисполнители</span>
            <span>
              <a onClick={handleAddUserModal.bind(this, 3)}>Добавить</a>
            </span>
          </div>
          {coExecuters.map((item, index) => {
            if (!item.info?.id) return null;
            return (
              <div className="flex between w100 vertCenter">
                <ShortManInfo
                  key={`coex${index}`}
                  photo={item.info?.photo}
                  name={item.info?.name}
                  last_name={item.info?.last_name}
                  first_name={item.info?.first_name}
                  phone={item.info?.phone}
                />
                <span>
                  <a onClick={handleDeleteUserModal.bind(this, item.info.id)}>
                    Удалить
                  </a>
                </span>
              </div>
            );
          })}
        </div>
        <div className="columnLeft gap12 taskInfoRow">
          <div className="flex between w100 vertCenter">
            <span>Наблюдатели</span>
            <span>
              <a onClick={handleAddUserModal.bind(this, 4)}>Добавить</a>
            </span>
          </div>
          {spectators.map((item, index) => {
            if (!item.info?.id) return null;
            return (
              <div className="flex between w100 vertCenter">
                <ShortManInfo
                  key={`spec${index}`}
                  photo={item.info?.photo}
                  name={item.info?.name}
                  last_name={item.info?.last_name}
                  first_name={item.info?.first_name}
                  phone={item.info?.phone}
                />
                <span>
                  <a onClick={handleDeleteUserModal.bind(this, item.info.id)}>
                    Удалить
                  </a>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TaskInfoSidePanel;
